const findElement = (doc: Document, property: string) =>
  doc.getElementsByTagNameNS('*', property)[0] ??
  doc.getElementsByTagName(property)[0] ??
  doc.getElementsByTagName(`t:${property}`)[0];

export const parseXml = (response: string): Document =>
  new DOMParser().parseFromString(response, 'text/xml');

const toDocument = (response: string | Document) =>
  typeof response === 'string' ? parseXml(response) : response;

export const parseResponse = (response: string | Document, properties: string[]) => {
  const doc = toDocument(response);

  return properties.map((property) => findElement(doc, property)?.textContent || null);
};

/**
 * Reads an attribute instead of the text content. Some EWS values live only in
 * attributes - `<t:ItemId Id="..." ChangeKey="..."/>` has no text content at
 * all, so `parseResponse` would report it as missing.
 */
export const parseResponseAttribute = (
  response: string | Document,
  property: string,
  attribute: string,
): string | null => findElement(toDocument(response), property)?.getAttribute(attribute) || null;
